import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';

// 引用 component
import CarouselDefault from 'component/carousel/carousel_default';
import IndexAppDownload from 'component/indexAppDownload';
import IndexCountUp from 'component/countUp/countUp_default';
import CountUp001 from 'component/countUp/countUp_001';
import CountUp002 from 'component/countUp/countUp_002';
import Titlebar from 'component/titleBar/titleBar_default';
import GameEmntranceDefault from 'component/gameEntrance/gameEntrance_default';
import NoticeBoard from 'component/noticeBoard/noticeBoard_default';
import MarqueeDefault from 'component/marquee/marguee_default';
import Shortcut from 'component/shortcut';
import LotteryBlock from 'component/lottery-block';

// 引用樣式
import './index.css';
import Themes from 'themes';

const ThemeContext = React.createContext(Themes.themes1);

const IndexView = () => {
  const { t } = useTranslation();
  const Themes = useContext(ThemeContext);
  return (
    <Container fluid>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} className="padding-0 hasTop66 fullHeight">
          <MarqueeDefault />
          <CarouselDefault />
          <Shortcut />
          <CountUp002 />
          <div className="hasBG">
            <Container>
              <Row>
                <Col xs={1} sm={1} md={1} lg={1} xl={1} xxl={1} />
                <Col xs={22} sm={22} md={22} lg={22} xl={22} xxl={22}>
                  <div className="contentBox" style={{ background: Themes.contentBox }}>
                    <Container className="withoutPadding">
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={6} xl={7} xxl={7}>
                          <Titlebar title={t('TitleBar.title1')} />
                          <GameEmntranceDefault />
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={6} xl={5} xxl={5}>
                          <Titlebar title={t('TitleBar.title2')} classNames={'mbNone'} />
                          <CountUp001 class={'count001 mbNone'} />
                          <NoticeBoard />
                        </Col>
                      </Row>
                    </Container>
                    <Titlebar title={t('TitleBar.title3')} />
                    <LotteryBlock />
                    <IndexAppDownload />
                    <Titlebar title={t('TitleBar.title4')} classNames={'mbNone'} />
                    <IndexCountUp />
                  </div>
                </Col>
                <Col xs={1} sm={1} md={1} lg={1} xl={1} xxl={1} />
              </Row>
            </Container>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default IndexView;
